import * as types from "../action/ActionType";

interface RequiredInvoiceAction {
  type: string;
  payload: unknown[];
}

export default function Requiredinvoice(
  state: unknown[] = [],
  action: RequiredInvoiceAction
): unknown[] {
  const { type, payload } = action;
  switch (type) {
    case types.REQUIRED_INVOICE:
      return payload;
    default:
      return state;
  }
}
